import { ERROR_500 } from '../../constants/localizations/app';
import Text from '../Text';
import ErrorPage from './ErrorPage';

const Error500 = () => <ErrorPage httpStatusCode={500} message={<Text name={ERROR_500} />} />;

export default Error500;
